import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSiteFeatures } from "@/models";
import { AppState } from "@/redux/store/store";

export const fetchSiteFeatures = createAsyncThunk(
  "siteFeatures/fetchSiteFeatures",
  async (_, { rejectWithValue, getState }) => {
    const { site } = getState() as AppState;

    const { id } = site.site;
    const filters = { siteId: id };

    try {
      const response = await getSiteFeatures({ filters });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
